import * as React from 'react';
import {Chip, Stack} from '@mui/material';
import type {BranchStatusRow} from '../../hooks/useDashboard';

/**
 * Renders the evidence-status chips shared by the desktop table and its mobile card variant.
 * One chip per non-empty state so approved, awaiting-approval and in-preparation records are never mixed:
 * "No evidence" (no records) | "In preparation" | "Awaiting approval" | "Approved" (all approved = "Completed").
 */
export function evidenceChip(row: BranchStatusRow, t: (key: string, options?: any) => any): React.ReactElement {
    if (row.evidenceTotal === 0) {
        return <Chip label={t('dashboard.branchStatus.evidence.none')} size="small" variant="outlined"/>;
    }
    if (row.evidenceApproved === row.evidenceTotal) {
        return <Chip label={t('dashboard.branchStatus.evidence.completed')} size="small" color="success"/>;
    }
    return (
        <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap justifyContent="flex-end">
            {row.evidenceInPreparation > 0 && (
                <Chip
                    label={t('dashboard.branchStatus.evidence.inPreparation', {count: row.evidenceInPreparation})}
                    size="small"
                    color="warning"
                />
            )}
            {row.evidenceSubmitted > 0 && (
                <Chip
                    label={t('dashboard.branchStatus.evidence.submitted', {count: row.evidenceSubmitted})}
                    size="small"
                    color="info"
                />
            )}
            {row.evidenceApproved > 0 && (
                <Chip
                    label={t('dashboard.branchStatus.evidence.approved', {count: row.evidenceApproved})}
                    size="small"
                    color="success"
                    variant="outlined"
                />
            )}
        </Stack>
    );
}
